import React from "react";

const StyledCustomHeading = ({ children, font }) => {
  return (
    <h2
      className={`text-custom font-star-jedi lowercase leading-[120%] ${font}`}
    >
      {children}
    </h2>
  );
};

export default StyledCustomHeading;
